module.exports = __webpack_public_path__ + "img/744.81a04e68.jpg";